import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlineLoader from "@Shared/components/general/inline-loader";
import { postMainApi } from "@Shared/utils/ajax";
import ClientProfileChangelog from "@Broker/@Modules/clients/board/client-profile/components/timeline/changelog/client-profile-changelog.vue";
import TimelineList from "../timeline/timeline-list";
import { mapActions, mapGetters, mapState } from "vuex";
import { LOAD_TIMELINE, LOAD_CHANGELOG } from "@Broker/@Modules/clients/board/store/board-actions";
import VueContentLoading from "vue-content-loading";
import ActivityConvertModal from "../timeline/convert-to-activity/activity-convert-modal";
import ScrollableContainer from "@Shared/components/general/scrollable-container";
import { capitalize } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineContainer",
  components: {
    TimelineList,
    VueContentLoading,
    ClientProfileChangelog,
    InlineLoader,
    ActivityConvertModal,
    ScrollableContainer
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      default: () => ({})
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    loadingChangelog: {
      type: Boolean,
      default: false
    },
    timelineTab: {
      type: String,
      default: ""
    },
    applications: {
      type: Object,
      default: () => ({})
    },
    clientUsername: {
      type: String,
      required: true
    },
    limit: {
      type: Number,
      default: 20
    },
    offset: {
      type: Number,
      default: 0
    },
    loadingMoreTimeline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentTab: "all",
      loading: true,
      initialized: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", ["filterTimelineList"])), mapState("BoardStore", {
    subscribers() {
      var _this$profile$notifie;
      return (_this$profile$notifie = this.profile.notifiedReferrers) == null ? void 0 : _this$profile$notifie.allIds;
    },
    details() {
      return this.profile;
    },
    changelog() {
      return this.profile.changelog;
    }
  })), {}, {
    timelineList() {
      return this.filterTimelineList({
        id: this.clientProfileId,
        filter: this.currentTab
      });
    },
    isEmptyTimeline() {
      var _context;
      return _reduceInstanceProperty(_context = this.timelineList).call(_context, (isEmpty, current) => isEmpty && !current.items.length, true);
    },
    tabs() {
      return [{
        name: "pinned",
        label: "<i class='fa fa-thumb-tack' aria-hidden='true'></i>"
      }, {
        name: "all",
        label: this.$tc("global.words.all", 1)
      }, {
        name: "changelog",
        label: this.$t("global.words.changeLog")
      }, {
        name: "note",
        label: capitalize(this.$tc("global.words.note", 2))
      }, {
        name: "follow-up",
        label: capitalize(this.$tc("global.words.activity", 2))
      }, {
        name: "email",
        label: capitalize(this.$tc("global.words.email", 2))
      }, {
        name: "file",
        label: capitalize(this.$tc("global.words.file", 2))
      }, {
        name: "checklist",
        label: this.$tc("global.words.checklist", 2)
      }, {
        name: "automation",
        label: this.$tc("global.doorr.automation", 2)
      }, {
        name: "client-application-request",
        label: this.$tc("global.doorr.request", 2)
      }, {
        name: "event",
        label: this.$tc("global.words.meeting", 2)
      }];
    },
    isChangelog() {
      return this.currentTab === "changelog";
    }
  }),
  watch: {
    currentTab: {
      handler(value) {
        this.$emit("update:timeline-tab", value);
        if (value === "changelog") return this.loadChangelog();
      },
      immediate: true
    }
  },
  mounted() {
    this.init();
  },
  activated() {
    // prevent it from being called alongside mounted;
    if (this.initialized) this.init();
  },
  deactivated() {
    setTimeout(() => {
      this.loading = true;
    }, 0);
  },
  updated() {
    this.$nextTick(() => {
      $("[data-toggle='tooltip']").tooltip();
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_TIMELINE, LOAD_CHANGELOG])), {}, {
    activeItem(tab) {
      return this.currentTab === tab;
    },
    setCurrentTab(tab) {
      this.currentTab = tab;
    },
    changeTimelineAction(action, data) {
      this.$emit("change-action", action, data);
    },
    markEmailAsRead() {
      return postMainApi({}, `/client/profile/${this.clientProfileId}/read`);
    },
    init() {
      this.LOAD_TIMELINE({
        id: this.clientProfileId,
        limit: this.limit,
        offset: 0
      }).then(() => {
        this.loading = false;
        this.initialized = true;
      });
      this.markEmailAsRead();
      this.$nextTick(() => {
        $("[data-toggle='tooltip']").tooltip();
      });
    },
    async loadTimeLine() {
      this.LOAD_TIMELINE({
        id: this.clientProfileId,
        limit: this.limit,
        offset: this.offset
      });
    },
    async loadChangelog() {
      this.loading = true;
      await this.LOAD_CHANGELOG({
        clientProfileId: this.clientProfileId
      });
      this.loading = false;
    }
  })
});